import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

export default function HeroSection() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    // Small delay so the stagger animations feel intentional after page load
    const t = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <header className="relative w-full h-screen min-h-[600px] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://framerusercontent.com/images/mTbsVbfZdq18aBHoh7vxgikvI.png"
          alt="Pacific Wrestling Alliance"
          className="w-full h-full object-cover object-top scale-105 transition-transform duration-[8000ms] ease-out"
          style={{ transform: loaded ? "scale(1)" : "scale(1.05)" }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/55 to-black/20" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-transparent to-black/30" />
        {/* Diagonal decorative line */}
        <div className="absolute bottom-0 right-0 w-96 h-96 border-r border-b border-orange-500/15 pointer-events-none" />
        <div className="absolute top-24 right-20 w-48 h-48 border border-white/5 pointer-events-none" />
      </div>

      {/* Decorative orange glow */}
      <div className="absolute bottom-1/3 left-1/4 w-80 h-80 bg-orange-500/8 rounded-full blur-3xl pointer-events-none animate-glow-pulse" />

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-end pb-20 md:pb-28 px-6 md:px-16 lg:px-24 w-full">
        <div className="max-w-2xl">
          {/* Badge */}
          <div
            className={`inline-block bg-orange-500 text-white font-condensed font-bold text-xs uppercase tracking-widest px-3 py-1 mb-5 anim-hidden ${
              loaded ? "animate-fade-in-left" : ""
            }`}
          >
            USA&apos;s Premier Wrestling Alliance
          </div>

          {/* Title lines — staggered */}
          <h1 className="font-condensed font-black text-white uppercase leading-none mb-5">
            {["Pacific", "Wrestling", "Alliance"].map((word, i) => (
              <span
                key={word}
                className={`block text-5xl md:text-7xl lg:text-8xl tracking-tight anim-hidden ${
                  loaded ? "animate-fade-in-left" : ""
                } ${i === 0 ? "italic delay-100" : i === 1 ? "delay-200" : "delay-300"}`}
              >
                {word}
              </span>
            ))}
          </h1>

          {/* Subtitle */}
          <p
            className={`text-white/80 font-barlow text-base md:text-lg mb-8 max-w-md leading-relaxed anim-hidden ${
              loaded ? "animate-fade-in-up delay-400" : ""
            }`}
          >
            Join a community that pushes limits and celebrates every victory — big or small.
          </p>

          {/* Buttons */}
          <div
            className={`flex flex-col sm:flex-row gap-4 anim-hidden ${
              loaded ? "animate-fade-in-up delay-500" : ""
            }`}
          >
            <Link
              to="/events"
              className="inline-flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white font-condensed font-bold text-sm uppercase tracking-widest px-7 py-3.5 transition-all duration-200 cursor-pointer whitespace-nowrap hover:gap-3 group"
            >
              Get Your Tickets Now
              <i className="ri-arrow-right-line transition-transform duration-200 group-hover:translate-x-1" />
            </Link>
            <Link
              to="/roster"
              className="inline-flex items-center gap-2 border-2 border-white text-white hover:bg-white hover:text-zinc-900 font-condensed font-bold text-sm uppercase tracking-widest px-7 py-3.5 transition-all duration-200 cursor-pointer whitespace-nowrap group"
            >
              Meet The Roster
              <i className="ri-arrow-right-line transition-transform duration-200 group-hover:translate-x-1" />
            </Link>
          </div>
        </div>

        {/* Scroll indicator */}
        <div
          className={`absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 anim-hidden ${
            loaded ? "animate-fade-in-up delay-700" : ""
          }`}
        >
          <span className="text-white/40 font-condensed text-xs uppercase tracking-[0.2em]">Scroll</span>
          <div className="w-px h-10 bg-gradient-to-b from-white/40 to-transparent" />
        </div>
      </div>
    </header>
  );
}
